export default {
  payChannel: 'Canal de pagamento',
  cashierDesk: 'Caixa',
  billAddress: 'Endereço de fatura',
  paySuccess: 'Pagamento bem-sucedido',
  payError: 'Falha no pagamento',
  harvestAddress: 'Endereço de entrega',
  orderAddress: 'Endereço de fatura',
  selectAddress: 'Selecionar endereço de entrega',
  addOrderAddress: 'Por favor, adicione o endereço de fatura primeiro',
  addSelectAddress: 'Por favor, selecione o endereço de entrega',
  noAddress: 'Sem endereço de entrega',
  holder: {
    inputPayPwd: 'Por favor, insira a senha de pagamento',
    returnExchange:
      'Você ainda não concluiu o pagamento da taxa de serviço, não pode continuar processando sua solicitação de devolução/troca',
  },
  transferTitle: 'Transferência bancária',
  changeAddress: 'Alterar endereço',
  editText: 'Editar',
  payWithbalance: 'Pagar com saldo',
  bankTransferRemittance: 'Transferência bancária',
  transferTips:
    'acbuy transferência sem taxa de serviço, quanto maior o valor do pedido, mais você economiza!',
  pay: 'Recarga com desconto',
  plsSetPsd: 'Por favor, defina a senha de pagamento',
  thirdPayTips: 'Pagamento com cobertura global e múltiplas moedas',
  payProcessing: 'Processando pagamento',
  payWaitingText: 'Tempo de espera estimado de 1-2 minutos, aguarde o resultado do pagamento',
  coinpalTips:
    'Recarga com moeda digital (moeda virtual) não suporta reembolso/saque. Se você aceitar, continue com a recarga',
  payStatusTips:
    'Ainda não obtivemos o resultado do seu pagamento, por favor, confirme o status do seu pagamento.',
  payErrorStatusTips: 'Falha no pagamento, por favor, altere para outro método de pagamento',
  sepaTips:
    'Os depósitos na SPEA não são reembolsáveis nem podem ser levantados. Se aceitar estas condições, por favor, continue a depositar.',
}
